import * as Yup from "yup";

export type TFormFieldNames = "email" | "password";
export const formInitialValues = {
  email: "",
  password: "",
};

export const emailValidationRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const YupValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required("Email is required")
    .matches(emailValidationRegex, "Please enter a valid email address"),

  password: Yup.string().required("Password is required"),
  // further validation is disabled to allow old users to log in
  // .min(APP_CONFIG.PASSWORD.MIN_LENGTH, `Password is too short - should be minimum ${APP_CONFIG.PASSWORD.MIN_LENGTH} chars`),
});
